import { combineReducers } from "@reduxjs/toolkit";
import { History } from "history";

import { connectRouter } from "connected-react-router";
import globalSlice from "./globalSlice";
import posConfigReducer from "../pages/Applications/Pos/PosProjectSetup/PosConfigurationModal/posConfigSlice";


const createRootReducer = (history: History) =>
    combineReducers({
        router: connectRouter(history),
        global: globalSlice,
        posConfig: posConfigReducer,

    });

export default createRootReducer;
